
export default {
    name: 'reference-operation',
    components: {},
    props: {
        reference_operation: Object
    },
    data() {
        return {
            fields: [
                { key: 'ref', label: 'Référence' }, "date", { key: 'libelle', label: 'Libellé' },
                "patient", { key: 'entree', label: 'Entrées' }, { key: 'sortie', label: 'Sorties' },
            ],
            perPage: 15,
            filter: "",
            currentPage: 1,
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}


